import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Utils
import { navigate } from '@toolkit/util/app';
import { isMultiCitySearch, isRentalOnlySearch } from '@src/shared/src/util/search';
// Constants
// Models
import {
  SettingsModel,
  SearchModel,
  SearchSectionModel,
  PassengerModel,
} from '@src/shared/src/models';
// Interfaces
import { IRootState } from '@src/store';
// Components
import { Button } from '@toolkit/ui';
import SearchSideBarPassengerInfo from './SearchSideBarPassengerInfo';
import SearchSideBarRouteInfo from './SearchSideBarRouteInfo';
import SearchSideBarTravelPolicies from './SearchSideBarTravelPolicies';
// Styles

type Props = {
  search: SearchModel;
  loyaltyCards: SettingsModel[];
  currentHaul?: string;
  hideResetButton?: boolean;
};

const SearchSideBarInfo: React.FC<Props> = ({ search, currentHaul, hideResetButton }) => {
  const { t } = useTranslation();
  const redeemingAllowance = useSelector((state: IRootState) => state.checkout.redeemingAllowance);
  const hideResetBtn = hideResetButton || redeemingAllowance;
  const [policiesPassenger, setPoliciesPassenger] = React.useState<PassengerModel | null>(null);

  if (policiesPassenger) {
    return (
      <aside className="sidebar sidebar-trip is--open">
        <div className="sidebar-wrapper">
          <SearchSideBarTravelPolicies
            passenger={policiesPassenger}
            currentHaul={currentHaul}
            onBack={() => setPoliciesPassenger(null)}
          />
        </div>
      </aside>
    );
  }

  return (
    <div className="sidebar-inner hidden-xs-down">
      {isMultiCitySearch(search) ? (
        search.sections.map((section: SearchSectionModel, index: number) => (
          <SearchSideBarRouteInfo
            key={`section-${index}`}
            title={`${t('TripSideBarInfo.route')} ${index + 1}`}
            from={section.depName}
            to={section.arrName}
            depAt={section.depAt}
          />
        ))
      ) : (
        <SearchSideBarRouteInfo
          title={t('TripSideBarInfo.title')}
          from={isRentalOnlySearch(search) ? search.depName : search.sections?.[0]?.depName}
          to={search.sections?.[0]?.arrName ?? search.arrName}
          depAt={search.sections?.[0]?.depAt ?? search.depAt}
          arrAt={search.sections?.[1]?.depAt ?? search.arrAt}
        />
      )}

      <SearchSideBarPassengerInfo onOpenTravelPolicies={setPoliciesPassenger} />
      {!hideResetBtn && (
        <Button onClick={() => navigate('/')} className="sidebar-reset button button-light">
          {t('TripSideBarInfo.button.reset')}
        </Button>
      )}
    </div>
  );
};

export default SearchSideBarInfo;
